angular.module("vgresiduos").directive("destinationSolicitation", function () {
	return {
		scope: true,
		controller: "DestinationSolicitationCtrl",
		controllerAs: "ctrl",
		templateUrl: "views/destination/stages/destinationSolicitation/destinationSolicitation_template.html"
	};
});
